export default __webpack_public_path__ + "static/miz-0160c84f4fce077252ef89954b86d899.svg";